module.exports = __webpack_public_path__ + "static/media/zvonimir_baljak.03ce899f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/zvonimir_baljak.jpg
// module id = 213
// module chunks = 0